import { createTheme } from '@one-thd/sui-atomic-components';

const RyobiPrimary = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

RyobiPrimary.palette['--sui-palette-background-primary'] = '222 226 41';

export { RyobiPrimary };
